// src/constants/api-endpoint.js

export const API_ENDPOINTS = {
  LINE_WEBHOOK: "lineWebhookHandler",
  LOGIN: "login",
  MEMBER_REGISTRATION_SAVE: "member-registration/save", // メンバー情報登録用エンドポイント
  MEMBER_REGISTRATION_GET: "member-registration/get", // メンバー情報取得用エンドポイント
  MEMBER_REGISTRATION_UPDATE: 'member-registration/update', //メンバー情報更新用エンドポイント
  ROUTE_REGISTRATION_SAVE: 'route-registration/save', //ルート情報登録用エンドポイント
  ROUTE_REGISTRATION_GET: 'route-registration/get', //ルート情報取得用エンドポイント
  ROUTE_REGISTRATION_UPDATE: 'route-registration/update', //ルート情報更新用エンドポイント
  CHECK_REGISTRATION: "check-registration", // 新しい登録確認用エンドポイント
  PHOTO_PERMISSION_SAVE: "photo-permission-save",  // 写真使用許可保存用エンドポイント
  CONFIDENTIALITY_AGREEMENT_SAVE: "confidentiality-agreement-save",  // 秘密保持誓約書保存用エンドポイント
  NEW_MEMBER: "new-member", // 管理者向けユーザー登録用エンドポイント
  ADMIN_MEMBER_LIST: "admin-member-list" // メンバー一覧取得用エンドポイント
  , ADMIN_MEMBER_EXPORT: "admin-member-export" // メンバー一覧CSVエクスポート用エンドポイント
  , POSTAL_CODE: (zipcode) => `postal-code/${zipcode}` // 郵便番号→住所検索
  , ADMIN_MEMBER_DETAIL: (id) => `admin-member-detail/${id}` // メンバー詳細
  , BRANCHES: "branches" // 拠点一覧
  , CONSENTS: "consents" // 同意・誓約状態
  , PASSWORD_CHANGE: "password/change" // パスワード変更
  , PASSWORD_RESET: (userId) => `password/reset/${userId}` // パスワードリセット（管理者）
  , ADMIN_MEMBER_REGISTRATION_SAVE: "admin-member-registration/save" // 管理者既存メンバー一括登録
  , QUALIFICATIONS: "qualifications" // 資格取得報告
  , QUALIFICATION: (id) => `qualifications/${id}` // 資格取得報告（個別）
  , QUALIFICATION_ATTACHMENT: (id) => `qualifications/${id}/attachment` // 資格の証跡
  , QUALIFICATIONS_BY_USER: (userId) => `qualifications/user/${userId}` // 指定ユーザーの資格一覧
  , DOCUMENTS: "documents" // 書面一覧（管理者）
  , DOCUMENTS_PENDING: "documents/pending" // 再署名が必要な書面
  , DOCUMENT_CURRENT: (key) => `documents/${key}/current` // 現行の書面
  , DOCUMENT_VERSIONS: (key) => `documents/${key}/versions` // 書面のバージョン履歴
  , DOCUMENT_VERSION: (key, version) => `documents/${key}/versions/${version}` // 書面の特定バージョン
};
